import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import {
	Slide,
	Trigger,
} from './thumbStyles';

import PicThumb from './picThumb';
import VidThumb from './vidThumb';

import { getYoutubeThumb, isImage as isImg } from 'core/utils';

class ThumbSorter extends Component {
	thumbRef = createRef()

	scrollThumb = thumb => {
		const parent = thumb.parentElement;
		const pWidth = parent.clientWidth;
		const ourWidth = thumb.clientWidth;

		const ourLocation = thumb.offsetLeft;
		const halfParentWidth =  pWidth / 2;
		const halfOurSize = ourWidth / 2;

		const idealLocation = ourLocation + halfOurSize - halfParentWidth;

		parent.scrollTo({
			behavior: 'smooth',
			left: idealLocation,
		});
	}

	render () {
		const {
			name, url, thumbnail, trigger, ratio,
			isImage, isCurrent, isLazy, maxIndex,
			listingName, photoNum
		} = this.props;

		const { thumbRef } = this;

		return (
			<Slide ref={thumbRef}>
				<Trigger onClick={trigger}>
					{isImage || isImg(url)
						? <PicThumb name={name || `${listingName} Photo ${photoNum + 1}`} url={thumbnail || url} isCurrent={isCurrent} isLazy={isLazy} ratio={ratio} soloItem={maxIndex === 1} />
						: <VidThumb name={name} url={getYoutubeThumb(url)} isCurrent={isCurrent} isLazy={isLazy} ratio={ratio} soloItem={maxIndex === 1} />
					}
				</Trigger>
			</Slide>
		);
	}

	componentDidUpdate(prevProps) {
		const { isCurrent } = this.props;
		const notCurrent = isCurrent === false;
		const currentDidNotChange = prevProps.isCurrent === isCurrent;
		if (notCurrent || currentDidNotChange) return;
		const { thumbRef, scrollThumb } = this;
		const thumb = thumbRef.current;
		if (! thumb) return;
		return scrollThumb(thumb);
	}

	static propTypes = {
		url: PropTypes.string.isRequired,
		thumbnail: PropTypes.string,
		name: PropTypes.string,
		isImage: PropTypes.bool,
		trigger: PropTypes.func,
		isCurrent: PropTypes.bool,
		ratio: PropTypes.string,
		isLazy: PropTypes.bool,
		maxIndex: PropTypes.number,
		listingName: PropTypes.string,
		photoNum: PropTypes.number,
	}
}

export default ThumbSorter;
